import { useEffect, useState } from "react";
import { waLink, SITE } from "@/data/site";

/** Floating WhatsApp click-to-chat button, bottom-right on every page. */
export default function FloatingWhatsApp() {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setExpanded(true), 1400);
    const t2 = setTimeout(() => setExpanded(false), 6000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label={`Message ${SITE.name} on WhatsApp`}
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-3 pr-3 text-white shadow-softlg transition-transform duration-300 hover:-translate-y-0.5"
    >
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/15">
        <svg viewBox="0 0 32 32" className="h-6 w-6 fill-white" aria-hidden="true">
          <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.117.553 4.187 1.605 6.01L4 29l8.17-1.57a11.94 11.94 0 0 0 3.833.63h.003C22.62 28.06 28 22.677 28 16.057 28 9.437 22.623 3 16.003 3zm0 21.86h-.002a9.9 9.9 0 0 1-3.46-.62l-.248-.093-4.85.932.94-4.727-.16-.244a9.86 9.86 0 0 1-1.51-5.256c0-5.46 4.443-9.902 9.9-9.902 2.644 0 5.127 1.03 6.996 2.9a9.83 9.83 0 0 1 2.9 6.996c0 5.462-4.44 9.914-9.9 9.914zm5.43-7.415c-.297-.15-1.758-.868-2.03-.967-.272-.099-.47-.148-.668.15-.198.297-.767.967-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.884-.788-1.48-1.76-1.653-2.057-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.15-.174.198-.298.297-.496.099-.198.05-.372-.025-.52-.075-.15-.668-1.612-.916-2.206-.24-.579-.485-.5-.668-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.478 1.065 2.875 1.213 3.073c.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.29.173-1.414-.074-.124-.272-.198-.57-.347z" />
        </svg>
      </span>
      <span
        className={`overflow-hidden whitespace-nowrap font-sans text-sm font-600 transition-all duration-300 ${
          expanded ? "max-w-[180px] pr-2 opacity-100" : "max-w-0 opacity-0"
        }`}
      >
        Chat with us
      </span>
    </a>
  );
}
